import * as type from './mutation-types'
import * as API from './api'
import { ajax } from '@/utils/fetch'

// 用户信息
export const getUserInfo = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETUSERINFO_REQUEST, data)
        // http 请求
    return ajax.post(
        API.getUserInfo, {
            commit
        },
        data,
        type.GETUSERINFO_RECEIVE
    )
};